export default "__VITE_ASSET__b602ada5__"